import { ChangeDetectionStrategy, Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { IConversationIDsAPIResponseNormalized } from '../../../../shared/models/conversation-ids.model';
import { Tooltip, TooltipModule } from 'primeng/tooltip';
import { NgTemplateOutlet } from '@angular/common';
import { MessageService } from 'primeng/api';
import { IDataQueryParam } from '../../../../store/actions';
import { ClickOutsideDirective } from '../../../../shared/directives/click-outside.directive';

@Component({
  selector: 'cv-conversation-ids',
  standalone: true,
  imports: [TooltipModule, NgTemplateOutlet, ClickOutsideDirective],
  templateUrl: './conversation-ids.component.html',
  styleUrl: './conversation-ids.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ConversationIdsComponent {
  @ViewChild(Tooltip) tooltip?: Tooltip;
  @Input({ required: true }) ids: IConversationIDsAPIResponseNormalized | null = null;
  @Input({ required: true }) currentId: IDataQueryParam | null = null;

  constructor(private readonly toastService: MessageService) {}

  showTooltip(): void {
    this.tooltip?.show();
  }

  hideTooltip(): void {
    this.tooltip?.hide();
  }

  async onCopy(value: string | number): Promise<void> {
    this.toastService.add({
      severity: 'success',
      summary: 'Copied',
      detail: 'ID is copied to clipboard',
    });
    this.triggerEscapeKeyPress();
    await navigator.clipboard.writeText(String(value));
  }

  private triggerEscapeKeyPress(): void {
    const event = new KeyboardEvent('keydown', {
      key: 'Escape',
    });
    document.dispatchEvent(event);
  }
}
